module.exports = __webpack_public_path__ + "img/bild-g.b4e853e6.png";